<template>
  <div>
    <TitlePage :title="$t('blacklist')"></TitlePage>

    <v-form @submit.prevent="update()" class="bb-gray pb-5" ref="form_create" v-model="check">

      <v-layout wrap>

        <v-flex md12 class="d-flex pt-5 pb-5">
          <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
        </v-flex>

        <v-flex md3 class="pl-4 pr-4">
          <v-text-field :label="$t('name')" v-model="customer.name" readonly></v-text-field>
        </v-flex>

        <v-flex md3 class="pl-4 pr-4">
          <v-text-field :label="$t('surname')" v-model="customer.surname" readonly></v-text-field>
        </v-flex>

        <v-flex md6 class="pl-4 pr-4">
          <template v-if="item.status === 'to_be_approved'">
            <v-select :items="list_status" :label="$t('status')" v-model="item.status" item-value="value" item-text="label" :readonly="!this.getUser.super_admin" :disabled="!this.getUser.super_admin"></v-select>
            <v-checkbox label="Approvare la segnalazione ?" v-model="item.approved" color="success" hide-details class="" :readonly="!this.getUser.super_admin" :disabled="!this.getUser.super_admin"></v-checkbox>
          </template>
          <template v-else>
            <v-select :items="list_status" :label="$t('status')" v-model="item.status" item-value="value" item-text="label" ></v-select>
            <!--            <v-checkbox label="Approvare la segnalazione ?" v-model="item.approved" color="success" hide-details></v-checkbox>-->
          </template>
        </v-flex>
      </v-layout>

      <CustomerStats :user-id="$route.params.customer_id" />
      <v-layout wrap>

<!--        <v-flex md6 class="pl-4 pr-4" v-if="customer.blacklists">-->
<!--          <p><strong>Nome:</strong> {{customer.name+' '+customer.surname}}</p>-->
<!--          <p><strong>Segnalazioni totali:</strong> {{customer.blacklist_report}}</p>-->
<!--          <p><strong>N° di Blacklist in cui è Bloccato:</strong> {{customer.blacklists.filter(obj => obj.status === 'active').length}}</p>-->
<!--          <p><strong>N° di Blacklist in cui è Rimosso:</strong> {{customer.blacklists.filter(obj => obj.status === 'canceled').length}}</p>-->
<!--          <p><strong>N° di Blacklist in cui è Da Approvare:</strong> {{customer.blacklists.filter(obj => obj.status === 'to_be_approved').length}}</p>-->
<!--        </v-flex>-->




        <v-flex md12 class="pb-10 d-flex">
          <v-divider class="marg-title"></v-divider>
        </v-flex>


        <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
          <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            {{ $t('back') }}
          </v-btn>
          <template v-if="item.status !== 'to_be_approved'">
            <v-btn elevation="2" color="primary" class="ml-auto" type="submit">
              {{ $t('save') }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </template>
        </v-flex>

      </v-layout>

    </v-form>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CustomerStats from "@/components/customers/CustomerStats.vue";

export default {
  name: "EditBlacklist",
  components: {CustomerStats, TitlePage},
  data() {
    return {
      customer: {
        name: null,
        surname: null
      },
      item: {
        _old_object: null,
        _id: null,
        user_id: null,
        center_id: null,
        approved: null,
        status: null, // to_be_approved - active - canceled
        created_at: new Date(),
      },
      check: true,
      list_status: [
        // {value:'to_be_approved',label:'In Revisione'},
        {value:'active',label:'Bloccato'},
        {value:'canceled',label:'Riabilitato'},
      ]

    };
  },
  async created(){
    this.setLoading(true);
    let fetchItem = await this.editItem(this.$route.params)
    this.customer = fetchItem.result
    let find_blacklist = fetchItem.result.blacklists.find((el)=> el._id.toString() === this.$route.params.id)
    if(find_blacklist){
      this.item._old_object = JSON.parse(JSON.stringify(find_blacklist))
      this.item.status = find_blacklist.status
      this.item.approved = find_blacklist.approved
    }
    this.setLoading(false);
  },

  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem': 'blacklists/edit',
      'updateItem': 'blacklists/update',
    }),
    async update(){

      this.$refs.form_create.validate()
      if(!this.check){
        return
      }

      await this.setLoading(true);
      let result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.customer = result.result.result

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

  },
  computed: {
    ...mapGetters({
      'getUser':'user/getUser'
    }),
  },

  mounted() {

  },
}
</script>

<style scoped>

</style>